export const ENUM_STEP_PROFILETYPE = 0;
export const ENUM_STEP_DOCWARNING = 1;
export const ENUM_STEP_AZDOMAINS = 2;
export const ENUM_STEP_APPDOMAIN = 3;
export const ENUM_STEP_URI = 4;
export const ENUM_STEP_PROFILEINPUTS = 5;
export const ENUM_STEP_CREATIONSUCCESS = 6;
export const ENUM_STEP_ERROR_409 = 7;
